<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    草埔站<br>
站点介绍<br>
草埔站地处深圳市原布吉海关联检大楼南侧，深惠路中央分隔带上，西侧为广深铁路及布吉公交总站，南侧为现有海鲜、农批市场，东边为城中村的居民私宅，属城市待开发地区。该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:05	23:39	3号线	2分15-20秒	4分30秒<br>
双龙	06:10	23:34	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:14	23:39	3号线	3分15秒	5分钟<br>
双龙	06:19	23:34	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:14	00:39	3号线	3分15秒	5分钟<br>
双龙	06:19	00:34	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口（新增出入口）:<br>
龙岗大道（东）、草埔村、吓围村、东晓派出所、金稻田路、福安购物广场<br><br>
B出入口:<br>
龙岗大道（东）、文锦北路、草埔村、吓围村、马岗新村、东晓派出所、金稻田路、福安购物广场<br><br>
D1出入口:<br>
龙岗大道（西）、海鲜批发市场、天乐大厦<br><br>
D2出入口:<br>
草埔地铁公交站<br><br>
D3出入口:<br>
清水河村、深圳进元大厦<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 草埔地铁站<br>
308，369，323，303，312，357，366，307，836，956，M203，M240,M224,27,18,M267,201,高峰专线11,M269,M283,M485,深惠3A,322,398,977,M358,E24 , M404,M406,M476,大鹏假日专线8,321,M403,M408,N17,2,N19,M511,N6,高快巴士20, 222,M402,213,371,376,377,M192,M239大站快线 、假日专线11、假日专线12、 假日专线13 M183、 956<br><br>
B出入口:<br>
公交站名： 草埔地铁站(与A出入口为同一个公交站台)<br>
323,371,376,377,383,M404,M406,M476,观光购物线，303,307,308,312,321,369,M403,M408,M414,N19,M224,M358,222,309,357,366,M203,M402,836,M485,322,373,374,375,398,977,M283,M421,956,M267,M269,深惠3A，高峰32,18,19<br><br>
D2出入口:<br>
公交站名： 草埔地铁站<br>
201,213,M240,高峰专线11,308,312,376,977,M406,M402,M403,M404,18,27,N17,357,366,377,836,322,369,M203,M267,M269,,371,398,M224,M414,M485,M408，N19，M283 M239、 M239大站快线、 956、 大鹏假日专线8 、 M192、 假日专线11、 假日专线13、 M183<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>